import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { useMessagePolling } from '../../../../api/denaliAssistant'
import Card from '../../../../components/molecules/Card'
import MessageAttachments from './MessageAttachments'
import MessageContent from './MessageContent'
import MessageHeader from './MessageHeader'

const useStyles = makeStyles((theme) => ({
  message: {
    padding: '0 !important',
    borderRadius: '12px',
    border: '1px solid transparent',
    transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    // '&:hover': {
    //   border: '1px solid var(--color-primary-500)'
    // },
    fontFamily: 'var(--font-serif)'
  },
  userMessage: {
    marginLeft: '-16px',
    marginRight: '-16px',
    padding: 'var(--dim-4) !important',
    fontFamily: 'var(--font-sans)',
    borderColor: 'var(--dai-color-border1)',
    backgroundColor: 'var(--dai-color-surface3)'
  },
  avatar: {
    width: '20px',
    height: '20px',
    borderRadius: 'var(--border-radius-round)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontSize: '18px'
  },
  userAvatar: {
    backgroundColor: 'var(--color-primary-600)',
    color: 'var(--color-contrast-primary-600)'
  },
  agentAvatar: {
    backgroundColor: 'var(--color-ai-500)',
    color: 'var(--color-contrast-ai-500)',
    fill: 'var(--color-contrast-ai-500)',
    stroke: 'var(--color-contrast-ai-500)'
  }
}))

function Message ({ parentInfo, message, hideMessageHeader }) {
  const classes = useStyles()
  const isUser = message.actor === 'user'

  // Default to showing explainability during generation, hidden when complete
  const [showExplainability, setShowExplainability] = useState(false)

  // Poll for updates if message is generating
  useMessagePolling(message)

  return (
    <Card variant={isUser ? undefined : 'clear'} className={`${classes.message} ${isUser ? classes.userMessage : ''}`}>
      {hideMessageHeader ? null : (
        <MessageHeader
          message={message}
          showExplainability={showExplainability}
          onExplainClick={() => setShowExplainability(p => !p)}
        />
      )}

      <div className={classes.messageContent}>
        <MessageContent
          parentInfo={parentInfo}
          message={message}
          showExplainability={showExplainability}
          isGenerating={message.isGenerating}
        />
        {/* Show attachments for messages that have large data */}
        {!isUser && <MessageAttachments message={message} />}
      </div>
    </Card>
  )
}

Message.propTypes = {
  parentInfo: PropTypes.shape({
    parentId: PropTypes.string,
    parentType: PropTypes.oneOf(['schedule', 'thread'])
  }),
  hideMessageHeader: PropTypes.bool,
  message: PropTypes.shape({
    threadMessageId: PropTypes.string,
    actor: PropTypes.oneOf(['user', 'assistan']).isRequired,
    message: PropTypes.string.isRequired,
    data: PropTypes.object,
    attachments: PropTypes.array,
    isGenerating: PropTypes.bool,
    generationStatus: PropTypes.string,
    isPlaceholder: PropTypes.bool,
    createdDate: PropTypes.string
  }).isRequired
}

export default Message
